export function buildUrl(apiVersion: string, item: string) {
    if (item.length > 0)
        return  `/${apiVersion}/${item}`;

    return `/${apiVersion}`;
}